<template lang="pug">
  .back.transparent-btn.color-purple.xs-f-xsmall.max-at-tweak
    router-link(v-if='url' :to="url")
      span.icon-caret-left
      |  Back

    a(v-else @click.prevent="$router.go(-1)" href="")
      span.icon-caret-left
        |  Back
  
</template>

<script>
  export default {
    name: "BackButton",
    props: {
      url: {
        type: String,
        required: false,
        default: null
      }
    }
   }
</script>

<style scoped lang="stylus">
  .back
    padding 0 0 1.8em

    .icon-caret-left
      &:before
        margin-left 0

</style>